import React, { useEffect, useState } from "react";

import { useTranslation } from "react-i18next";

import { Button, TextPlain, TitleH2 } from "components/generic";
import mainImg from "assets/images/hospi-housing-contact-banner.d0239fcf.jpg";
import TextArea, { useTextArea } from "components/TextArea";
import { ContactGrid, ContactImg, ContactP, ContactTitle, FormSend } from "./styles";
import Select, { useSelect } from "components/Select"
import { HeaderSEO } from "components/headerSEO";
import { IEmail, ISeo } from "interfaces/intarfaces";
import Modal from "components/Modal";
import {ContentDiv, DialogWrapper } from "components/containers";
import { FAQ_ROUTE } from "utils/constants";
import { SmallLoader } from "../../../components/SmallLoader";
import {useNavigate} from "react-router-dom";

export const Contact: React.FC = () => {
  const { t, i18n } = useTranslation('contact');
  const navigate = useNavigate()
  const [required, setRequired] = useState(false);
  const [showModal, setShowModal] = useState<number>(0);

  const category_options = [
    {
      value: "QAfind",
      label: t("contact.form.category.qafind"),
    },
    {
      value: "QArent",
      label: t("contact.form.category.qarent"),
    },
    {
      value: "QAplatform",
      label: t("contact.form.category.qaplatform"),
    },
    {
      value: "Collaboration",
      label: t("contact.form.category.collaboration"),
    },
    {
      value: "Comment",
      label: t("contact.form.category.comment"),
    },
    {
      value: "Media",
      label: t("contact.form.category.media"),
    },
    {
      value: "General",
      label: t("contact.form.category.general"),
    }
  ]

  const category = {
    ...useSelect("")
  };

  const question = {
    ...useTextArea(""),
  };

  const [loading, setLoading] = useState(false);
  const [textLoader, setTextLoader] = useState("");

  const loadersTexts = {
    savingData: t("contact.loading"),
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const sendData = (e: React.FormEvent<HTMLFormElement>) => {
    setTextLoader(loadersTexts.savingData);

    e.preventDefault();

    const isEmpty = [
      e.currentTarget.first_name.value,
      e.currentTarget.last_name.value,
      e.currentTarget.email.value,
      category.value,
      e.currentTarget.question.value,
    ].every((x) => x.length);
    if (!isEmpty) { setRequired(true) }
    else {
      setLoading(true);
      const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          type: "contact_form",
          first_name: e.currentTarget.first_name.value as string,
          last_name: e.currentTarget.last_name.value as string,
          category: category.value as string,
          question: e.currentTarget.question.value as string,
          phone: e.currentTarget.tel.value as string,
          browser_language: i18n.language,
        } as IEmail),
      };

      fetch(
        process.env.REACT_APP_AWS_ENDPOINT! +
        `contact-us/${e.currentTarget.email.value as string}`,
        requestOptions
      )
        .then((response) => response.json())
        .then((data) => {
          setShowModal(1)
          setLoading(false);
        });
    }
    e.currentTarget.reset()
    question.onChange("")
    category.changeItem(undefined)
  };

  const seo = t("contact.seo", { returnObjects: true }) as ISeo;
  return (
    <ContentDiv>
      {seo && <HeaderSEO {...seo} />}
      <ContactTitle>{t("contact.title.1")}<span>{t("contact.title.2")}</span></ContactTitle>
      <ContactGrid>
        <ContactImg
          src={mainImg}
        />
        <ContactP>
          {t("contact.text.1")}
          <br /><br />
          {t("contact.text.2")}
          <a onClick={() => navigate(`/${i18n.language}${FAQ_ROUTE.slice(5)}`)}> FAQ </a>
          {t("contact.text.3")}
        </ContactP>
      </ContactGrid>
      <FormSend
        onSubmit={(e) => sendData(e as React.FormEvent<HTMLFormElement>)}
      >
        {/*  {loading && (*/}
        {/*  <LoaderCustom*/}
        {/*    size={5}*/}
        {/*    color={theme.colors.bgBody}*/}
        {/*    text={textLoader}*/}
        {/*  />*/}
        {/*)}*/}
        <div id="formTitle">
          <h2>{t("contact.form.title")}</h2>
        </div>
        <div id="firstnameDiv">
          <p>{t("contact.form.firstName")}</p>
          <input
            pattern="\D{2,30}"
            title={t("contact.form.nameError")}
            name="first_name"
            required={required}
          />
        </div>
        <div id="lastnameDiv">
          <p>{t("contact.form.lastName")}</p>
          <input
            pattern="\D{2,30}"
            title={t("contact.form.nameError")}
            name="last_name"
            required={required}
          />
        </div>
        <div id="emailDiv">
          <p>{t("contact.form.email")}</p>
          <input
            title={t("contact.form.nameError")}
            type="email"
            name="email"
            placeholder="emailaddres@domein.com"
            required={required}
          />
        </div>
        <div id="phoneDiv">
          <p>{t("contact.form.phone")}</p>
          <input
            title={t("contact.form.nameError")}
            type="tel"
            name="tel"
            placeholder="+31 61231212"
          />
        </div>
        <div id="categoryDiv">
          <p>{t("contact.form.category.title")}</p>
          <Select
            id="category"
            {...category}
            placeholder={t("contact.form.category.none")}
            items={category_options}
            required={required}
          />
        </div>
        <div id="questionDiv">
          <p>{t("contact.form.question")}</p>
          <TextArea
            {...question}
            id="questionText"
            name="question"
            required={required}
          />
        </div>
        <Button main type="submit" disabled={loading} style={{ minHeight: 38.8 }}>
          {
            loading ? (
              <SmallLoader height={16} borderWidth={2} color='white' />
            ) : (
              t("contact.form.butTetxt")
            )
          }
        </Button>
      </FormSend>
      {!!showModal && (
        <Modal isShow={!!showModal} handleClose={() => setShowModal(0)}>
          <DialogWrapper>
            <TitleH2
              style={{
                textAlign: "left",
              }}
            >
              {t(`contact.email.title`)}
            </TitleH2>
            <TextPlain
              style={{
                whiteSpace: "pre-line",
                wordBreak: "break-word",
                textAlign: "left",
              }}
            >
              {t(`contact.email.text`)}
            </TextPlain>
            <div className="buttons">
              <span />
              <Button main onClick={() => setShowModal(0)}>
                {t(`contact.closeBox`)}
              </Button>
            </div>
          </DialogWrapper>
        </Modal>
      )}
      <div style={{ height: 1, background: 'white' }} />
    </ContentDiv>
  );
};
